import {FC} from 'react'

type Props = {
  status?: 'Active' | 'Inactive' | 'Sold' | 'Expired'
}

const StatusCell: FC<Props> = ({status}) => {
  const getStatusBadge = () => {
    switch (status) {
      case 'Active':
        return <span className='badge badge-light-success'>Active</span>
      case 'Inactive':
        return <span className='badge badge-light-warning'>Inactive</span>
      case 'Sold':
        return <span className='badge badge-light-info'>Sold</span>
      case 'Expired':
        return <span className='badge badge-light-danger'>Expired</span>
      default:
        return <span className='badge badge-light-secondary'>-</span>
    }
  }

  return <div className='fw-bold'>{getStatusBadge()}</div>
}

export {StatusCell}

